import { defineMessages } from 'react-intl';

export default defineMessages({
    locationTitle:{
        id: 'wmic.pe-capability-quoteandbind-common-react.pages.location-coverages-table-component.locationTitle',
        defaultMessage: 'Location #{displayName}'
    },
});
